export default __webpack_public_path__ + "static/media/ScrewFreights.b37c536d.jpg";